import axiosInstance from '../axiosInterceptor/axiosInstance'

const getFederationSeasonTeamStats = async ({ orgId, teamId, seasonId, stageId }) => {
  const url = `v1/orgs/${orgId}/stats/teams/${teamId}`
  return axiosInstance.get(url, { params: { seasonId, ...(stageId ? { stageId } : {}) } })
}

export default getFederationSeasonTeamStats
